export default {"src":"/_next/static/media/red_heart.82a9af3a.svg","height":16,"width":18};